import Vue from 'vue';
import App from './App.vue';
import router from '@/routes/index';
import store from '@/store/index';
import vuetify from './plugins/vuetify';
import vueMoment from 'vue-moment';
import vClickOutside from 'v-click-outside';
import vuescroll from 'vuescroll';
import '@/utils/filters';
import 'vuescroll/dist/vuescroll.css';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';

Vue.use(vClickOutside);
Vue.use(vueMoment);
Vue.use(vuescroll, {
  ops: {
    rail: {
      background: '#eee',
      opacity: 1,
      size: '4px',
      gutterOfSide: '8px',
    },
    bar: {
      background: '#999',
      opacity: 1,
      size: '4px',
    },
  },
});

Vue.config.productionTip = false;

(window.__sessionReady || Promise.resolve()).then(() => {
  store.initFromSession();
  new Vue({
    router,
    store,
    vuetify,
    render: h => h(App),
  }).$mount('#app');
});
